<template>
  <el-dialog :visible.sync="formVisible" :close-on-click-modal="false" width="520px" class="approve-dialog"
    @close="handleClose">
    <div slot="title" class="dialog-title">
      <img src="../../../assets/icon-green.png" alt="approve" class="title-icon" />
      <div class="title-content">
        <div class="title-main">同意申请</div>
        <div class="title-sub">同意申请后修改的折扣才会生效</div>
      </div>
    </div>
    <div class="dialog-body">
      <div class="detail-box" v-if="currentRow">
        <div class="detail-item">
          <span class="label">用户信息：</span>
          <span class="value">{{ currentRow.customerInfo }}</span>
        </div>
        <div class="detail-item">
          <span class="label">申请内容：</span>
          <span class="value">{{ `原折扣${currentRow.fromProfitRatio}  修改成:${currentRow.toProfitRatio}` }}</span>
        </div>
        <div class="detail-item">
          <span class="label">申请原因：</span>
          <span class="value">{{ currentRow.reason || '-' }}</span>
        </div>
        <div class="detail-item" v-if="getVoucherImages(currentRow).length > 0">
          <span class="label">申请凭证：</span>
          <div class="voucher-imgs">
            <el-image v-for="(img, idx) in getVoucherImages(currentRow)" :key="idx"
              style="width: 60px; height: 60px; margin-right: 8px;" :src="img"
              :preview-src-list="getVoucherImages(currentRow)"></el-image>
          </div>
        </div>

      </div>
      <div class="applicant-info" v-if="currentRow">
        <div class="detail-item">
          <span class="label">申请人：</span>
          <span class="value">{{ currentRow.submitUserName }}</span>
        </div>
        <div class="detail-item">
          <span class="label">提交时间：</span>
          <span class="value">{{ currentRow.createdTime || '-' }}</span>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doApprove" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      formVisible: false,
      isLoading: false,
      currentRow: null
    }
  },
  methods: {
    handleCreate(row) {
      this.currentRow = row
      this.formVisible = true
    },
    handleClose() {
      this.currentRow = null
    },
    formatUserInfo(row) {
      if (!row) return '-'
      if (row.targetUserName && row.targetUserLevelName && row.targetUserMobile) {
        return `${row.targetUserName}-${row.targetUserLevelName}-${row.targetUserMobile}`
      }
      return row.userInfo || '-'
    },
    formatApplicantInfo(row) {
      if (!row) return '-'
      if (row.applicantName && row.applicantLevelName && row.applicantMobile) {
        return `${row.applicantName}-${row.applicantLevelName}-${row.applicantMobile}`
      }
      return row.applicantInfo || '-'
    },
    getVoucherImages(row) {
      if (!row) return []
      if (row.imgUrl) {
        return row.imgUrl.split(',').filter(Boolean)
      }
      return []
    },
    doApprove() {
      if (!this.currentRow || !this.currentRow.id) {
        this.$message.error('数据异常')
        return
      }
      this.isLoading = true
      this.$emit('approve', { id: this.currentRow.id }, () => {
        this.isLoading = false
        this.formVisible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.approve-dialog ::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
}

.approve-dialog ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}

.dialog-title {
  display: flex;
  gap: 20px;
  align-items: center;

  .title-icon {
    width: 60px;
  }

  .approve-icon {
    color: #67c23a;
  }

  .title-content {
    .title-main {
      font-size: 18px;
      color: #000000;
    }

    .title-sub {
      font-size: 14px;
      color: #8F8E8E;
      padding-top: 10px;
    }
  }
}

.detail-box {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .detail-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 16px;
    line-height: 14px;

    &:last-child {
      margin-bottom: 0;
    }

    .label {
      color: #666666;
      display: inline-block;
    }

    .value {
      color: #6C6C6C;
    }

    .voucher-imgs {
      display: flex;
      flex-wrap: wrap;
      gap:10px;
    }
  }
}

.applicant-info {
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 20px;
  font-size: 16px;
  color: #666666;

  .detail-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    color: #666666;

    .label,
    .value {
      color: #666666;
    }
  }
}
</style>
